<header class="app-header">
    <ngx-loading [show]="isLoading"></ngx-loading>
    <div>
        @if (title) {
            <div class="title-section">
                @if (brandIconName) {
                    <div class="title-section-brand-icon">
                        <i class="float-start media-box-object rounded-circle marca {{brandIconName}}"></i>
                    </div>
                }
                <div class="title-section-texts">
                    <p class="title">{{title}}</p>
                    @if (subtitle) {
                        <p class="subtitle">{{subtitle}}</p>
                    }
                </div>
                @if (shouldCopyTitleInfo) {
                    <a href="javascript:void(0)" class="chaticon text-muted-custom no-print ml" (click)="copyTitleInfo()">
                        <i class="fa icons fa-copy popup fa-1x"></i>
                    </a>
                }
            </div>
        }
        @if (filterInput && filterOptions.length > 0) {
            <div class="filter-section">
                <div class="input-group">
                    @if (filterLabel) {
                        <span class="input-group-text">
                            {{filterLabel}}
                        </span>
                    }
                    <select class="form-select" [(ngModel)]="filter">
                        @for (option of filterOptions; track option) {
                            <option [value]="option.value">{{option.label}}</option>
                        }
                    </select>
                </div>
            </div>
        }
        @if (searchPlaceholder) {
            <div class="search-section">
                <form class="input-group" (submit)="searchControl(search)">
                    <span class="input-group-text"><i class="fa fa-search"></i></span>
                    @if (searchMask) {
                        <input [type]="searchType" [mask]="searchMask" maxlength="100" [placeholder]="searchPlaceholder" class="form-control" name="search" [(ngModel)]="search" />
                    } @else {
                        <input [type]="searchType" maxlength="100" [placeholder]="searchPlaceholder" class="form-control" name="search" [(ngModel)]="search" />
                    }

                    @if (hasSearchButton) {
                        <button class="btn btn-primary input-group-text" type="submit" [disabled]="hasMinCharacters && (search?.toString().length < 2) ? 'disabled' : null">{{'elemento.generico-botao.pesquisar' | translate}}</button>
                    }
                </form>
            </div>
        }
        @if (hasButtons) {
            <div class="buttons-section">
                <ng-content></ng-content>
                @if (hasBackButton) {
                    <button class="btn btn-light float-end go-back-button" (click)="goBack()">{{'elemento.generico-botao.voltar' | translate}}</button>
                }
            </div>
        }
    </div>
</header>
